const communities = [
  { name: "Blue Springs", dist: "8 min" },
  { name: "Grain Valley", dist: "12 min" },
  { name: "Raytown", dist: "15 min" },
  { name: "Grandview", dist: "18 min" },
  { name: "Belton", dist: "22 min" },
  { name: "Raymore", dist: "25 min" },
  { name: "Pleasant Hill", dist: "20 min" },
  { name: "Greenwood", dist: "10 min" },
  { name: "Oak Grove", dist: "20 min" },
];

const stats = [
  { value: "100K+", label: "Greater Lee's Summit population served" },
  { value: "24 hrs", label: "Fastest processing available" },
  { value: "25 min", label: "Drive saved to Downtown KC agency" },
  { value: "A+", label: "BBB Rating" },
];

export default function LeeSummitLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              Lee&apos;s Summit &amp; Jackson County Passport Services
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              Lee&apos;s Summit is the second-largest city in Jackson County and one of the most affluent suburbs in the Kansas City metro. With over 100,000 residents, a thriving corporate corridor along US-50, and Longview Community College drawing students internationally, passport demand is consistently high. The nearest Regional Passport Agency is in Downtown Kansas City — a 25-minute drive — but appointments are competitive and limited. We serve the entire southeast Jackson County area.
            </p>
            <div className="grid grid-cols-2 gap-4 mb-8">
              {stats.map((s, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-4">
                  <p className="font-bold text-2xl text-[#1A365D] mb-1">{s.value}</p>
                  <p className="text-gray-500 text-xs">{s.label}</p>
                </div>
              ))}
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0f2240] text-white font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
            >
              Start My Application <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-6 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-4">Communities We Serve</h3>
              <div className="grid grid-cols-2 gap-3">
                {communities.map((c, i) => (
                  <div key={i} className="flex items-center justify-between bg-white rounded-md px-3 py-2">
                    <span className="text-gray-700 text-sm font-medium">{c.name}</span>
                    <span className="text-[#F6C344] text-xs font-semibold">{c.dist}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-6 text-white">
              <h3 className="font-bold text-[#F6C344] text-sm mb-3">Why Lee&apos;s Summit Residents Choose Us</h3>
              <ul className="space-y-2.5">
                {[
                  "Longview Community College study-abroad deadlines met every semester",
                  "Corporate travelers along US-50 corridor to Mexico and Canada",
                  "Jackson County families with last-minute Cancun and Caribbean trips",
                  "No need to fight KC appointment system — we have reserved slots",
                  "Documents reviewed before submission — no costly rejections",
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-white/80">
                    <i className="ri-check-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}